import PropTypes from 'prop-types';

import getStructuredDataAttributes from '../lib/StructuredDataAttributes';

const JsonLdVideo = ({
  name,
  description,
  embedUrl,
  thumbnailUrl,
  uploadDate,
  duration = '',
  contentUrl = '',
  interactionCount = ''
}) => {
  const properties = getStructuredDataAttributes();

  const structuredData = {
    '@context': 'https://schema.org/',
    '@type': 'VideoObject',
    name,
    description,
    thumbnailUrl,
    uploadDate,
    ...(!!duration && { duration }),
    ...(!!contentUrl && { contentUrl }),
    embedUrl,
    ...(!!interactionCount && { interactionCount }),
    publisher: {
      '@type': 'Organization',
      name: properties.name,
      image: '',
      logo: properties.logo,
      address: '',
      telephone: ''
    }
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(structuredData)
      }}
    />
  );
};

JsonLdVideo.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  embedUrl: PropTypes.string.isRequired,
  thumbnailUrl: PropTypes.string.isRequired,
  uploadDate: PropTypes.string.isRequired,
  duration: PropTypes.string,
  contentUrl: PropTypes.string,
  interactionCount: PropTypes.number
};

export default JsonLdVideo;
